















import { Component, Prop, Vue } from "vue-property-decorator";
import { ConnectionQuality } from "livekit-client";

@Component({
  name: "QualityIndicator"
})
export default class QualityIndicator extends Vue {
  @Prop({default: ConnectionQuality.Unknown}) quality: ConnectionQuality;
    @Prop({ default: 16 }) size: number;

  get poor() {
    return this.quality == ConnectionQuality.Poor;
  }

  get soSo() {
    return false;//this.quality < 5;
  }

  get good() {
    return this.quality == ConnectionQuality.Good;
  }

  get perfect() {
    return this.quality == ConnectionQuality.Excellent;
  }

  get unknown() {
    return this.quality == ConnectionQuality.Unknown
  }

  get title() {
    if(this.perfect) {return this.$t("web-conferences.quality.good").toString();}
    if(this.good) {return this.$t("web-conferences.quality.mayBeProblems").toString();}
    if(this.poor) {return this.$t("web-conferences.quality.bad").toString();}

    return ""
  }

  get color(): string{
    if (this.poor) {
      return 'is-red';
    }
    if (this.good) {
      return 'is-yellow';
    }
    return 'is-green';
  }

  get isOffline() {
    //@todo find out how to identify it
    return false;//this.quality === 6;
  }

}
